/* ============================================================
   PADDY-GLOBAL.JS
   Genuinely global behaviour for the Paddy Pigeon homepage ONLY:
   the scroll-reveal utility shared by multiple homepage sections.
   Named separately from Dawn's own assets/global.js so nothing
   is overwritten or conflicts with Dawn's core script.

   Section-specific scripts (mobile drawer, stamp-card carousel,
   FAQ accordion, review-wall pagination, etc.) are NOT here -
   each ships inside its own section file during the section-by-
   section Liquid conversion.

   RE-OBSERVING IS NOT OPTIONAL. The observer must be re-applied
   whenever section markup is replaced. Shopify swaps a section's
   DOM on every edit in the theme editor, and theme hot-reload does
   the same on every file save. The replacement nodes carry
   .paddy-reveal but not .in, so if nothing re-observes them they
   stay at opacity 0 forever and the section silently disappears.
   That is a real bug that has bitten this theme before - do not
   reduce this back to a single pass over the document at load.
   ============================================================ */

(function () {
  var SEL = '.paddy-reveal';
  var io = null;

  function revealAll(root) {
    var els = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) els[i].classList.add('in');
  }

  if (!('IntersectionObserver' in window)) {
    revealAll(document);
    document.addEventListener('shopify:section:load', function (e) {
      revealAll(e.target || document);
    });
    return;
  }

  io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('in');
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function observe(root) {
    var els = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      if (!els[i].classList.contains('in')) io.observe(els[i]);
    }
  }

  observe(document);

  // Theme editor: Shopify re-renders the whole section on every edit.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target || document);
  });

  // Safety net for any other node replacement (hot reload, app embeds).
  // Coalesced into one pass per frame so it stays cheap.
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function (records) {
      if (queued) return;
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            observe(document);
          });
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
